import { useEffect, useState } from 'react';
import { LoginDialog } from '../components/LoginDialog';
import { AUTH_SESSION_EXPIRED_EVENT } from '../lib/authEvents';

export function SessionExpiredHandler() {
  const [loginOpen, setLoginOpen] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    const onSessionExpired = () => {
      setSessionExpired(true);
      window.requestAnimationFrame(() => setLoginOpen(true));
    };
    window.addEventListener(AUTH_SESSION_EXPIRED_EVENT, onSessionExpired);
    return () => window.removeEventListener(AUTH_SESSION_EXPIRED_EVENT, onSessionExpired);
  }, []);

  const handleOpenChange = (open) => {
    setLoginOpen(open);
    if (!open) {
      setSessionExpired(false);
    }
  };

  return (
    <LoginDialog
      open={loginOpen}
      onOpenChange={handleOpenChange}
      sessionExpired={sessionExpired}
    />
  );
}
